import React, { useState } from "react";
import { Icons, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@curves/ui-base";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { isFunction } from "@util/utils";

const OverflowMenu = props => {
	const { menuAction = [], sourceData = {}, ...others } = props;
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleMoreIconClick = e => {
		setAnchorEl(e.currentTarget);
	};

	const handleClose = fn => {
		if (anchorEl) {
			anchorEl.focus(); // 把焦點移回 IconButton
		}
		isFunction(fn) && fn(sourceData, { ...others });
		setAnchorEl(null);
	};

	return (
		<React.Fragment>
			<IconButton onClick={handleMoreIconClick}>
				<Icons.MoreVertical />
			</IconButton>
			<Menu className={clsx("more-label-box-menu")} anchorEl={anchorEl} open={open} onClose={e => handleClose()} disablePortal={false}>
				{menuAction.map(({ label, to, onClick: onClickProps, icon: Icon }) => {
					const menuProperty = {
						onClick: () => handleClose(onClickProps),
					};
					if (to) {
						menuProperty.to = isFunction(to) ? to(sourceData) : to;
						menuProperty.component = NavLink;
					}
					return (
						<MenuItem key={label} {...menuProperty}>
							<ListItemIcon>{React.isValidElement(Icon) ? Icon : Icon ? <Icon /> : null}</ListItemIcon>
							<ListItemText>{label}</ListItemText>
						</MenuItem>
					);
				})}
			</Menu>
		</React.Fragment>
	);
};

export default OverflowMenu;
